<script setup lang="ts">
const props = defineProps<{
  name?: string;
  imageUrl?: string;
}>();

const backgroundUrl = toRef(() => `url(${props.imageUrl})`);
</script>

<template>
  <div class="service">
    <div class="service__name">
      {{ props.name }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.service {
  display: block;
  aspect-ratio: 16 / 10;
  padding: stretch-size(375, 1920, 10, 15);
  border-radius: 16px;
  background:
    linear-gradient(rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%),
    v-bind(backgroundUrl) no-repeat 0 0 / cover;
  color: var(--app-color-white-primary);
  font-weight: var(--app-fw-bold);
}
</style>
